export const IDENTITY_TIMEOUT = 5000;
export const NUANCE_TIMEOUT = 45000;
